export const initCF7CustomSelect = (parent = document) => {
    const wrappers = parent.querySelectorAll('.custom-select-wrapper');

    wrappers.forEach(wrapper => {
        const realSelect = wrapper.querySelector('select');
        if (!realSelect || wrapper.querySelector('.select-trigger')) return;

        // 1. Create the UI
        const trigger = document.createElement('div');
        trigger.className = 'select-trigger';
        trigger.textContent = realSelect.options[realSelect.selectedIndex].text;

        const menu = document.createElement('div');
        menu.className = 'custom-options';

        // 2. Build Options
        [...realSelect.options].forEach((opt, index) => {
            if (!opt.value && !opt.text) return;
            const item = document.createElement('div');
            item.className = 'custom-option';
            item.textContent = opt.text;
            
            // --- THE MANUAL OPTION CLICK ---
            item.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();

                console.log("Manual Option Clicked:", opt.text);

                // Update the real hidden select
                realSelect.selectedIndex = index;
                realSelect.value = opt.value;

                // Update visual trigger
                trigger.textContent = opt.text;

                // Close menu
                wrapper.classList.remove('open');

                // Tell CF7 the value changed
                realSelect.dispatchEvent(new Event('change', { bubbles: true }));
                realSelect.dispatchEvent(new Event('input', { bubbles: true }));
            };

            menu.appendChild(item);
        });

        // --- THE MANUAL TRIGGER CLICK (The one that worked) ---
        trigger.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log("Manual trigger click detected!");
            wrapper.classList.toggle('open');
        };

        wrapper.append(trigger, menu);
    });
};